import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=3acb7e66&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=3acb7e66&prod&lang=less&scoped=true"
import style1 from "./teacher.vue?vue&type=style&index=1&id=3acb7e66&prod&lang=less"
import style2 from "./teacher.vue?vue&type=style&index=2&id=3acb7e66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb7e66",
  null
  
)

export default component.exports